import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Slider, Stack, Typography } from '@mui/material';

import { styles } from './index.styles';

export const INSIGHT_WHEEL_SLIDER_TEST_ID = 'insight-wheel-slider';

export interface InsightWheelSliderProps {
  sliderCurrentValue: number;
  sliderMinValue: number;
  sliderMaxValue: number;
  onSliderChange: (_e: Event, newValue: number | number[]) => void;
}

const InsightWheelSlider: FC<InsightWheelSliderProps> = ({
  onSliderChange,
  sliderCurrentValue,
  sliderMinValue,
  sliderMaxValue,
}) => {
  const { t } = useTranslation('dashboard');

  return (
    <Stack direction="column" spacing={1}>
      <Stack sx={styles.sliderLabels} direction="row">
        <Typography component="span" sx={{ pl: 1 }}>
          {t('InsightWheel.SliderText')}
        </Typography>
        <Box>
          <Typography sx={styles.sliderValue}>{sliderCurrentValue} </Typography>
          {t('InsightWheel.Subtopics')}
        </Box>
      </Stack>
      <Box sx={{ pl: 1 }}>
        <Slider
          sx={styles.slider}
          data-test-id={INSIGHT_WHEEL_SLIDER_TEST_ID}
          value={sliderCurrentValue}
          onChange={onSliderChange}
          min={sliderMinValue}
          max={sliderMaxValue}
          color="primary"
        />
      </Box>
    </Stack>
  );
};

export default InsightWheelSlider;
